import { getQueryMethod, resources, entities, methods } from '../utils';
const { meloAPI } = resources;
const { open } = entities;
const { POST } = methods;

const query = getQueryMethod(meloAPI, open);

const endpoints = {
  registerUser: async body => {
    return await query('signup', POST, body);
  }
};

export default endpoints;
